<template>
  <div class="data_download" id="data_download"
       :class="{'overHide': isShow || isLoading}"
       @scroll="handleScroll()">
    <div class="data_download_content">
      <div>
        <label>店铺：</label>
        <div class="inb">
          <el-select class="w291" v-model="selectStore" @change="getDockingSynchTypeList" placeholder="请选择">
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div>
        <label>平台订单号：</label>
        <input type="text" title="平台订单号" v-model.trim="orderNum">
        <button class="btn_normal ml40" @click="downOrderById()">单笔订单下载</button>
      </div>
      <div>
        <label>创建时间：</label>
        <div class="inb mr10">
          <el-date-picker
            v-model.trim="createOrderTimeStart"
            type="datetime"
            placeholder="开始时间">
          </el-date-picker>
        </div>
        至
        <div class="inb ml10">
          <el-date-picker
            v-model.trim="createOrderTimeEnd"
            type="datetime"
            placeholder="结束时间">
          </el-date-picker>
        </div>
        <button class="btn_normal ml40" @click="downOrderByCreateTime()">按创建时间进行订单下载</button>
      </div>
      <div>
        <label>平台售后单号：</label>
        <input type="text" title="平台售后单号" v-model.trim="salesNum">
        <button class="btn_normal ml40" @click="downReOrderById()">单笔售后单下载</button>
      </div>
      <div>
        <label>创建时间：</label>
        <div class="inb mr10">
          <el-date-picker
            v-model.trim="createSalesTimeStart"
            type="datetime"
            placeholder="开始时间">
          </el-date-picker>
        </div>
        至
        <div class="inb ml10">
          <el-date-picker
            v-model.trim="createSalesTimeEnd"
            type="datetime"
            placeholder="结束时间">
          </el-date-picker>
        </div>
        <button class="btn_normal ml40" @click="downReOrderByCreateTime()">按创建时间进行下载售后单</button>
      </div>
      <div>
        <label>链接ID：</label>
        <input type="text" title="链接ID" v-model.trim="linkID">
        <button class="btn_normal ml40" @click="downGoodsByLinkId()">平台链接商品下载</button>
        <button class="btn_normal ml20" @click="downShopGoodsList()">下载整店商品</button>
      </div>
      <!--订单表格信息-->
      <div class="data_download_tabel">
        <table class="table">
          <thead>
          <tr>
            <th>类型</th>
            <th>同步时间</th>
            <th>频率</th>
            <th>？停用</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in ctrlList" :key="index">
            <td>{{item.DockingTypeName}}</td>
            <td>
              <div class="w_percent60 wMin180 mauto">
                <el-date-picker
                  v-model.trim="item.LastTime"
                  type="datetime"
                  placeholder="选择日期时间" align="center">
                </el-date-picker>
              </div>
              <!--format="yyyy/MM/dd hh:mm:ss"-->
            </td>
            <td>{{item.PingRate}}</td>
            <td>{{item.IsStop | isstop}}</td>
            <td>
              <a title="重置下载时间" @click="ctrlBtn('resetTime', item)">重置下载时间</a>
              <a title="停用状态" v-if="item.IsStop === 0" @click="ctrlBtn('disable', item)">停用</a>
              <a title="启用状态" v-if="item.IsStop === 1" @click="ctrlBtn('enable', item)">启用</a>
              <!--<a title="启用状态" v-if="item.IsStop === 1" @click="changeShopStatusById(item)">停用</a>-->
            </td>
          </tr>
         <!-- <tr>
            <td>库存同步</td>
            <td>
              <el-date-picker
                v-model.trim="inventoryTime"
                type="datetime"
                placeholder="选择日期时间" align="center">
              </el-date-picker>
            </td>
            <td>{{inventoryStatus | status}}</td>
            <td>
              <a title="重置同步时间" @click="ctrlBtn('resetInventory', inventoryTime)">重置同步时间</a>
              <a title="启用状态" v-if="!inventoryStatus" @click="ctrlBtn('enableInventory', true)">启用</a>
              <a title="启用状态" v-if="inventoryStatus" @click="ctrlBtn('disableInventory', false)">停用</a>
            </td>
          </tr>
          <tr>
            <td>商品下载</td>
            <td>
              <el-date-picker
                v-model.trim="goodsTime"
                type="datetime"
                placeholder="选择日期时间" align="center">
              </el-date-picker>
            </td>
            <td>{{goodsStatus | status}}</td>
            <td>
              <a title="重置下载时间" @click="ctrlBtn('resetGoods', goodsTime)">重置下载时间</a>
              <a title="启用状态" v-if="!goodsStatus" @click="ctrlBtn('enableGoods', true)">启用</a>
              <a title="启用状态" v-if="goodsStatus" @click="ctrlBtn('disableGoods', false)">停用</a>
            </td>
          </tr>
          <tr>
            <td>售后单下载</td>
            <td>
              <el-date-picker
                v-model.trim="salesOrderTime"
                type="datetime"
                placeholder="选择日期时间" align="center">
              </el-date-picker>
            </td>
            <td>{{salesOrderStatus | status}}</td>
            <td>
              <a title="重置下载时间" @click="ctrlBtn('resetSales', salesOrderTime)">重置下载时间</a>
              <a title="启用状态" v-if="!salesOrderStatus" @click="ctrlBtn('enableSales', true)">启用</a>
              <a title="启用状态" v-if="salesOrderStatus" @click="ctrlBtn('disableSales', false)">停用</a>
            </td>
          </tr> -->
          </tbody>
        </table>
      </div>
    </div>

    <!--嵌入弹出框-->
    <data-download-embed-msg v-if="isShow"
                             :title="dialogTitle"
                             :orderMsg="orderMsg"
                             :shopId="selectStore"
                             :scrollLeft="scrollLeft"
                             :scrollHeight="scrollHeight"
                             :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></data-download-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"
                    :scrollTop="scrollHeight"></loading-dialog>
  </div>
</template>

<script type="es6">
  import DataDownloadEmbedMsg from './data-download-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'data-download',
    components: {DataDownloadEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        storeList: [
         /* {id: '尚动运动户外专营店', text: '尚动运动户外专营店'},
          {id: '炫动运动户外专营店', text: '炫动运动户外专营店'},
          {id: '藤吉运动户外专营店', text: '藤吉运动户外专营店'} */
        ], // 店铺下拉列表
        selectStore: '', // 选择的店铺
        ctrlList: [],
        orderNum: '', // 平台订单号
        createOrderTimeStart: '', // 订单创建时间——开始
        createOrderTimeEnd: '', // 订单创建时间——结束
        salesNum: '', // 平台售后单号
        createSalesTimeStart: '', // 售后单创建时间——开始
        createSalesTimeEnd: '', // 售后单创建时间——结束
        linkID: '', // 链接ID
        orderStatus: false, // 订单下载状态
        orderTime: '', // 订单下载同步时间
        inventoryStatus: false, // 库存同步状态
        inventoryTime: '', // 库存同步时间
        goodsStatus: false, // 商品下载状态
        goodsTime: '', // 商品下载同步时间
        salesOrderStatus: false, // 售后单下载状态
        salesOrderTime: '', // 售后单下载同步时间
        orderMsg: null, // 用户信息
        isLoading: false, // 加载框的显示
        loadingType: 'NOP', // 加载框显示的类型： NOP=普通加载框   options=操作加载框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        scrollLeft: 0, // 滚动宽度
        scrollHeight: 0, // 滚动高度
        isShow: false, // 提示框显示
        dialogTitle: '提示', // 弹出框头部名
        dialogShowType: null // 弹出框类型
      }
    },
    methods: {
      // 获取平台来源下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          console.log(res);
          if (!res.data.errorMsg) {
            if (res.data.resData.length > 0) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].id;
              this.getDockingSynchTypeList();
              this.getShopAppInfoById();
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 根据店铺Id获取数据下载的同步控制列表
      getDockingSynchTypeList() {
        if (typeof this.selectStore === 'number') {
          this.isLoading = true;
          this.loadingType = 'NOP';
          this.$axios.post(this.Global.getDockingSynchTypeList(this.selectStore), null).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.ctrlList = res.data.resData;
                 /* for (let i = 0; i < self.ctrlList.length; i++) {
                    self.$set(self.ctrlList, 'resetTime', null);
                  } */
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 根据店铺Id、类型Id更改同步控制是否停用
      changeShopStatusById(msg) {
        let typeStatus;
        if (msg.IsStop === 1) {
          typeStatus = 0;
        } else {
          typeStatus = 1;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.changeShopStatusById(this.selectStore, msg.DockingTypeId, typeStatus), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                // window.open(res.data.resData, '_blank');
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
                self.getDockingSynchTypeList();
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 单笔订单下载
      downOrderById() {
        this.isMsg = false;
        if (!this.orderNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入平台订单号';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.downOrderById(this.selectStore, this.orderNum, this.$cookies.get('_ati')), null).then((res) => {
            console.log(res);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res.data) {
                if (!res.data.errorMsg.length) {
                  // window.open(res.data.resData, '_blank');
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 按创建时间进行订单下载
      downOrderByCreateTime() {
        this.isMsg = false;
        if (!this.createOrderTimeStart) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择创建时间的开始时间';
        } else if (!this.createOrderTimeEnd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择创建时间的结束时间';
        } else if (this.createOrderTimeStart > this.createOrderTimeEnd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '创建时间的开始时间不能大于结束时间';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.downOrderByCreateTime(this.selectStore, new Date(this.createOrderTimeStart).toISOString(), new Date(this.createOrderTimeEnd).toISOString(), this.$cookies.get('_ati')), null).then((res) => {
            console.log(res);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res.data) {
                if (!res.data.errorMsg.length) {
                  // window.open(res.data.resData, '_blank');
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 单笔售后单下载
      downReOrderById() {
        if (!this.salesNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入平台售后单号';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.downReOrderById(this.selectStore, this.salesNum), null).then((res) => {
            console.log(res);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res.data) {
                if (!res.data.errorMsg.length) {
                  // window.open(res.data.resData, '_blank');
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 按创建时间进行售后单下载
      downReOrderByCreateTime() {
        if (!this.createSalesTimeStart) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择创建时间的开始时间';
        } else if (!this.createSalesTimeEnd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择创建时间的结束时间';
        } else if (this.createSalesTimeStart > this.createSalesTimeEnd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '创建时间的开始时间不能大于结束时间';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.downReOrderByCreateTime(this.selectStore, new Date(this.createSalesTimeStart).toISOString(), new Date(this.createSalesTimeEnd).toISOString()), null).then((res) => {
            console.log(res);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res.data) {
                if (!res.data.errorMsg.length) {
                  // window.open(res.data.resData, '_blank');
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 平台链接商品下载
      downGoodsByLinkId() {
        if (!this.linkID) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入平台链接商品的ID';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.downGoodsByLinkId(this.linkID, this.selectStore), null).then((res) => {
            console.log(res);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res.data) {
                if (!res.data.errorMsg.length) {
                  // window.open(res.data.resData, '_blank');
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 下载整店商品
      downShopGoodsList() {
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.downShopGoodsList(this.selectStore), null).then((res) => {
          console.log(res);
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                // window.open(res.data.resData, '_blank');
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 数据列表
      getShopAppInfoById() {
        this.$axios.get(this.Global.getShopAppInfoById(this.selectStore)).then((res) => {
          console.log(res);
          if (res && !res.data.errorMsg.length) {
            this.orderTime = res.data.resData.DockingOrderTime;
            this.orderStatus = res.data.resData.IsDockingOrder;
            this.inventoryTime = res.data.resData.DockingStockTime;
            this.inventoryStatus = res.data.resData.IsDockingStock;
            this.goodsTime = res.data.resData.DockingProductTime;
            this.goodsStatus = res.data.resData.IsDockingProduct;
            this.salesOrderTime = res.data.resData.DockingReOrderTime;
            this.salesOrderStatus = res.data.resData.IsDockingReOrder;
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, orderMsg) {
        if (type === 'resetTime' && !orderMsg.LastTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择时间';
          return;
        }
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsg = orderMsg;
       /* switch (type) {
          case 'enableOrder':
            this.orderStatus = true;
            break;
          case 'disableOrder':
            this.orderStatus = false;
            break;
          case 'enableInventory':
            this.inventoryStatus = true;
            break;
          case 'disableInventory':
            this.inventoryStatus = false;
            break;
          case 'enableGoods':
            this.goodsStatus = true;
            break;
          case 'disableGoods':
            this.goodsStatus = false;
            break;
          case 'enableSales':
            this.salesOrderStatus = true;
            break;
          case 'disableSales':
            this.salesOrderStatus = false;
            break;
        } */

        // 计时器
      /* let time = 6;
        const self = this;
        const timer = setInterval(function () {
          console.log(time);
          time = --time;
          if (time < 1) {
            self.isShow = false;
            clearInterval(timer);
          }
        }, 1000); */
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType && (e.showType === 'enable' || e.showType === 'disable')) {
          this.getDockingSynchTypeList();
        }
      },

      // 接受信息提示框内容
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 监听盒子滚动高度
      handleScroll() {
        this.scrollHeight = document.querySelector('#data_download').scrollTop;
        this.scrollLeft = document.querySelector('#data_download').scrollLeft;
      }
    },
    created() {
      this.getAllPXShopList();
    },
    activated() { // 只有keep-alive激活才会被使用
      this.handleScroll();
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        if (this.storeList.length > 0) {
          this.selectStore = this.storeList[0].id;
        }
        this.isShow = false;
        this.orderNum = '';
        this.createOrderTimeStart = '';
        this.createOrderTimeEnd = '';
        this.salesNum = '';
        this.createSalesTimeStart = '';
        this.createSalesTimeEnd = '';
        this.linkID = '';
        this.orderTime = '';
        this.orderStatus = false;
        this.inventoryTime = '';
        this.inventoryStatus = false;
        this.goodsTime = '';
        this.goodsStatus = false;
        this.salesOrderTime = '';
        this.salesOrderStatus = false;
        this.getAllPXShopList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";
  @import "../../../assets/css/home-view";

  .data_download {
    overflow: auto;

    &.overHide {
      overflow: hidden;
    }

    .data_download_content {
      padding-top: 30px;

      & > div {
        margin: 0 40px 20px;
        label {
          display: inline-block;
          width: 100px;
          text-align: right;
        }

        input {
          width: 269px;
        }

        textarea {
          width: 458px;
          height: 137px;
        }

        &.supplier_binding_content_address {
          display: flex;
          justify-content: left;
          align-items: center;
        }

        &.supplier_binding_content_btn {
          width: 570px;
          text-align: right;
        }
      }

      .data_download_tabel {
        .table {
          td {
            a {
              color: #169BD5;
              margin-right: 40px;
            }

            .el-date-editor.el-input, .el-date-editor.el-input__inner {
              width: 291px;
            }

            .el-input__icon {
              display: none!important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/data-download.vue